<template>
  <div class="list-item">
    <div class="flex-between-div">
      <div style="display: flex;flex-direction: column;justify-content: space-between;align-items: flex-start;">
        <div class="flex-start-div">
          <div class="price-color" style="display: flex;justify-content: flex-start;align-items: flex-end;">
            <div>{{isStraightCustomer ? '市场价' : '分销价'}}：</div>
            <div class="price-f">&yen;&nbsp;</div>
            <div class="font-big" style="line-height: 1.1;">{{ data.buyPrice }}</div>
          </div>
          <div style="display: flex;justify-content: flex-start;align-items: flex-end;font-size: 13px;color: #999999;">
            <div>售价：</div>
            <div>&yen;&nbsp;</div>
            <div style="line-height: 1.35;font-size: 14px;margin-right: 10px;">{{ data.publishPrice }}</div>
          </div>
          <div class="ticket-div" v-show="data.cabin.residualSeat !== '>9'">
            {{ data.cabin.residualSeat }}张
          </div>
        </div>
        <div class="flex-start-div" style="margin-top: 10px;">
          <template v-if="data.childBuyPrice > 0">
            <div style="display: flex;justify-content: flex-start;align-items: flex-end;font-size: 12px;color: #333333;margin-right: 10px;">
              <div>儿童{{isStraightCustomer ? '市场价' : '分销价'}}：</div>
              <div>&yen;&nbsp;</div>
              <div style="line-height: 1.35;font-size: 14px;">{{ data.childBuyPrice }}</div>
            </div>
            <div style="display: flex;justify-content: flex-start;align-items: flex-end;font-size: 13px;color: #999999;">
              <div>售价：</div>
              <div>&yen;&nbsp;</div>
              <div style="line-height: 1.35;font-size: 14px;">{{ data.childPrice }}</div>
            </div>
          </template>
        </div>
      </div>
      <div class="flex-end-div">
        <div
          class="btn-blue"
          style="margin-left: 1em"
          @click="handleViewDetail"
        >
          预定
        </div>
      </div>
    </div>
    <div class="text-list" @click="refundModalVisible = true">
      <span>{{ cabinMap[data.cabin.cabinType] }}&nbsp;</span>
      <span>{{ handleCalculatingDiscount(data.buyPrice) }}</span>
      <span>｜</span>
      <span>行李额</span>
      <span>｜</span>
      <span>退改信息 ></span>
    </div>
    <flights-refund-policy v-model="refundModalVisible" :baggageParam="data.baggageParam" :tgqParam="data.tgqParam"></flights-refund-policy>
  </div>
</template>
<script>
import FlightsRefundPolicy from './flights-refund-policy.vue';
export default {
  name: 'flights-query-item',
  components: { FlightsRefundPolicy },
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    cabinMap: {
      type: Object,
      default: () => ({}),
    },
    ycPublishPrice: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      refundModalVisible: false,
    }
  },
  computed: {
    isStraightCustomer: function() {
      if (this.$store.getters.userInfo_v2 && this.$store.getters.userInfo_v2.identity && this.$store.getters.userInfo_v2.identity.identityType && this.$store.getters.userInfo_v2.identity.identityType === '5') {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    handleViewDetail() {
      this.$emit('viewDetail', this.data);
    },
    handleCalculatingDiscount(buyPrice) {
      if (buyPrice >= this.ycPublishPrice) {
        return '无折扣';
      } else {
        return (
          ((buyPrice / this.ycPublishPrice) * 10).toString().slice(0, 3) + '折'
        );
      }
    },
  },
};
</script>

<style scoped>
.font-big {
  font-size: 18px;
  font-weight: bold;
}
.list-item {
  width: calc(100% - 20px);
  margin: 10px 10px 0 10px;
  padding: 10px 15px;
  box-sizing: border-box;
  background-color: #ffffff;
  border-radius: 10px;
}
.flex-between-div {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.flex-start-div {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.price-color {
  color: #3377ff;
  font-size: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 15px;
}
.price-f {
  box-sizing: border-box;
}

.ticket-div {
  color: #ff4c4c;
  border-radius: 0.25rem;
  font-size: x-small;
  box-sizing: border-box;
  padding: 0 0.25rem;
  width: max-content;
  border: 1px solid #ff4c4c;
}
.flex-end-div {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.btn-blue-k {
  border: 1px solid #3377ff;
  border-radius: 4px;
  color: #3377ff;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 1em;
  height: 34px;
}
.btn-blue {
  border: 1px solid #3377ff;
  background-color: #3377ff;
  border-radius: 4px;
  color: #ffffff;
  height: 34px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 1em;
}
.text-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 13px;
  color: #5c5f66;
  margin-top: 15px;
}
</style>
